export var DividerVariants;
(function (DividerVariants) {
    DividerVariants["neutral"] = "neutral";
    DividerVariants["primary"] = "primary";
    DividerVariants["error"] = "error";
})(DividerVariants || (DividerVariants = {}));
export var DividerWeights;
(function (DividerWeights) {
    DividerWeights["light"] = "light";
    DividerWeights["regular"] = "regular";
    DividerWeights["bold"] = "bold";
})(DividerWeights || (DividerWeights = {}));
export var DividerSizes;
(function (DividerSizes) {
    DividerSizes["soft"] = "soft";
    DividerSizes["medium"] = "medium";
    DividerSizes["strong"] = "strong";
})(DividerSizes || (DividerSizes = {}));
//# sourceMappingURL=constants.js.map